import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEYS = {
  AUTH_TOKEN: '@gambalunga:auth_token',
  USER_DATA: '@gambalunga:user_data',
};

// Token speichern
export const saveToken = async (token) => {
  try {
    await AsyncStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);
  } catch (error) {
    console.error('Fehler beim Speichern des Tokens:', error);
  }
};

// Token abrufen
export const getToken = async () => {
  try {
    return await AsyncStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  } catch (error) {
    console.error('Fehler beim Abrufen des Tokens:', error);
    return null;
  }
};

// Token löschen
export const removeToken = async () => {
  try {
    await AsyncStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
  } catch (error) {
    console.error('Fehler beim Löschen des Tokens:', error);
  }
};

// User-Daten speichern
export const saveUserData = async (userData) => {
  try {
    await AsyncStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(userData));
  } catch (error) {
    console.error('Fehler beim Speichern der User-Daten:', error);
  }
};

// User-Daten abrufen
export const getUserData = async () => {
  try {
    const data = await AsyncStorage.getItem(STORAGE_KEYS.USER_DATA);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Fehler beim Abrufen der User-Daten:', error);
    return null;
  }
};

// User-Daten löschen
export const removeUserData = async () => {
  try {
    await AsyncStorage.removeItem(STORAGE_KEYS.USER_DATA);
  } catch (error) {
    console.error('Fehler beim Löschen der User-Daten:', error);
  }
};

// Alles löschen (bei Logout)
export const clearAll = async () => {
  try {
    await AsyncStorage.multiRemove([STORAGE_KEYS.AUTH_TOKEN, STORAGE_KEYS.USER_DATA]);
  } catch (error) {
    console.error('Fehler beim Löschen aller Daten:', error);
  }
};

